import type { ScheduleGrid } from "../model/types";

import { HOUR_KEYS } from "../model/types";

export const createEmptyGrid = (): ScheduleGrid => ({
  fri: HOUR_KEYS.map(() => null),
  holiday: HOUR_KEYS.map(() => null),
  mon: HOUR_KEYS.map(() => null),
  sat: HOUR_KEYS.map(() => null),
  sun: HOUR_KEYS.map(() => null),
  thu: HOUR_KEYS.map(() => null),
  tue: HOUR_KEYS.map(() => null),
  wed: HOUR_KEYS.map(() => null),
});
